import gql from 'graphql-tag';

export const GENERATE_ZOOM_SETUP_LINK = gql`
  mutation generateZoomSetupLink($returnTo: String) {
    generateZoomSetupLink(returnTo: $returnTo) {
      ok
      link
    }
  }
`;
